import * as authHelper from './../../../../modules/auth/core/AuthHelpers'

import Dropdown from "react-bootstrap/esm/Dropdown"
import { FC } from "react"
import { IPageAction } from "../../../base/models"
import { MUIIcon } from "../../../widgets"
import { Property } from '../../../base/types'
import { getBaseUrl } from '../url-helper'
import { useGetProperties } from '../../../base/hooks'

interface IActionDropdownPortalLinkProps {
    action: IPageAction
}

export const ActionDropdownPortalLink: FC<IActionDropdownPortalLinkProps> = ({
    action
}) => {
    const { token } = authHelper.getAuth() || {}
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!token || !pageUrl)
        return <Dropdown.ItemText>{action.name}</Dropdown.ItemText>

    const base64Token = btoa(token)
    return (
        <Dropdown.Item
            target={target || undefined}
            href={`${getBaseUrl(pageUrl)}/auth/token-auth(${encodeURIComponent(base64Token)})`}>
            {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
            <span>{action.name}</span>
        </Dropdown.Item>
    )
}